import classes from './SwitchControl.module.css'

const SwitchControl = (props) => {
    return (
        <div className={classes.switchControl}
            style={{ backgroundImage: `url('${props.backgroundImg}')` }}
            onClick={props.changeMapStyle}>
            <p className={classes.switchControlText}>
                {props.text}
            </p>
        </div>
    );
};

export default SwitchControl;